import React, {useState} from "react";
import ErrorIcon from '@mui/icons-material/Error';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export const DuplicateMessage = (props) =>{

    const [open, setOpen] = useState(props.open);
    const handleClose = () => setOpen(false);

    return(
    <>
    <Modal
        open={open}
        //onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="checkInvoiceBox"
    >
        <Box sx={props.style}>
            <Typography id="modal-modal-description" sx={{ mt: 2, mb:2 }} textAlign="center">
                <ErrorIcon sx={{ fontSize: 60 }} color="warning" /> 
            </Typography>
            <Typography id="modal-modal-title" variant="h5" component="h2" alignItems="center" textAlign="center" color="warning" sx={{ mb:3 }} >
                    Payment Not Finalised
            </Typography>
            <Typography id="modal-modal-title" variant="body1" component="h2" alignItems="center" textAlign="center" sx={{mb:4}}>
                {props.message}
            </Typography>
         <TableContainer component={Paper}>
        <Table aria-label="simple table">
            <TableHead sx={{backgroundColor:'#dee2e6'}}>
            <TableRow>
                <TableCell align="center">Invoice No</TableCell>
                <TableCell align="center">Client No</TableCell>
                <TableCell align="center">Amount</TableCell>
                <TableCell align="center">Date Paid</TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                <TableCell align="center">{props.invoice}</TableCell>
                <TableCell align="center">{props.client}</TableCell>
                <TableCell align="center">{props.dollars}</TableCell>
                <TableCell align="center">{props.datePaid}</TableCell>
            </TableRow>
            </TableBody>
        </Table>
        </TableContainer> 
            <Typography id="modal-modal-title" variant="body1" component="p" alignItems="center" textAlign="center" sx={{ mb: 3, mt: 3 }}>
                        If you believe this to be a mistake please contact
            </Typography>
            <Typography id="modal-modal-title" variant="h6" component="p" alignItems="center" textAlign="center" sx={{ mb: 1 }}>
                <a href="mailto:AReceivable@cerebralpalsy.org.au">Accounts Receivable</a>
            </Typography>
            <Box textAlign="center" alignItems="center" justifyContent="center" sx={{mt:2}}>
            </Box>
        </Box>
    </Modal>
    </>
    )
    
}